module.exports = __webpack_public_path__ + "static/media/blog.42c1a399.jpg";